import {IAnalyticParams, IGtag} from "@/models/IAnalytics.ts";
import env from '@/services/env';
import {toUpper} from "ramda";


enum AnalyticActions {
  // routing action
  ROUTING = 'ROUTING',

  // button clicks
  CLICK = 'CLICK',

}


const clickLoginParam = (): IAnalyticParams => {
  return {
    action: AnalyticActions.CLICK,
    params: {
      event_category: "START_PAGE",
      event_label: `LOGIN`,
    },
  };
};


const clickInstallParam = (): IAnalyticParams => {
  return {
    action: AnalyticActions.CLICK,
    params: {
      event_category: "HOME",
      event_label: `INSTALL`,
    },
  };
};

const clickAtHome = (eventLabel: string): IAnalyticParams => {
  return {
    action: AnalyticActions.CLICK,
    params: {
      event_category: "HOME",
      event_label: eventLabel,
    },
  };
};

const clickRegisterParam = (): IAnalyticParams => {
  return {
    action: AnalyticActions.CLICK,
    params: {
      event_category: "START_PAGE",
      event_label: `REGISTER`,
    },
  };
};

const clickPlusButtonParam = (open: boolean = true): IAnalyticParams => {
  return {
    action: AnalyticActions.CLICK,
    params: {
      event_category: "DROPUP",
      event_label: `PLUS_BUTTON`,
      value: open ? 1 : 0,
    },
  };
};

const clickHubMapParam = (open: boolean = true): IAnalyticParams => {
  return {
    action: AnalyticActions.CLICK,
    params: {
      event_category: "DROPUP",
      event_label: `HUB_MAP`,
      value: open ? 1 : 0,
    },
  };
};

const clickIncomingTabParam = (open: boolean = true): IAnalyticParams => {
  return {
    action: AnalyticActions.CLICK,
    params: {
      event_category: "TAB",
      event_label: `INCOMING`,
      value: open ? 1 : 0,
    },
  };
};

const clickOutgoingTabParam = (open: boolean = true): IAnalyticParams => {
  return {
    action: AnalyticActions.CLICK,
    params: {
      event_category: "TAB",
      event_label: `OUTGOING`,
      value: open ? 1 : 0,
    },
  };
};


const clickAddressGeneration = (): IAnalyticParams => {
  return {
    action: AnalyticActions.ROUTING,
    params: {
      event_category: "PAGE",
      event_label: `ADDRESS_CREATED`,
      value: 1,
    },
  };
};


const enterCrosstownRouteParams = (enter: boolean = true): IAnalyticParams => {
  return {
    action: AnalyticActions.ROUTING,
    params: {
      event_category: "PAGE",
      event_label: `CROSS_TOWN_DELIVERY`,
      value: enter ? 1 : 0,
    },
  };
};

const sendAnalytics = ($gtag: IGtag, analyticEvent: IAnalyticParams) => {
  // we only will send the event in production.

  if (env.isProduction()) {
    $gtag.event(analyticEvent.action, analyticEvent.params);
  }
};

export const ANALYTIC_CLICKS = {
  dropupOpen:  ($gtag: IGtag) => sendAnalytics($gtag, clickAtHome('OPEN_DROPUP')),

  loginButton: ($gtag: IGtag) => sendAnalytics($gtag, clickLoginParam()),
  registerButton: ($gtag: IGtag) => sendAnalytics($gtag, clickRegisterParam()),

  hubMap: ($gtag: IGtag, open: boolean = true) => sendAnalytics($gtag, clickHubMapParam(open)),
  installApp: ($gtag: IGtag) => sendAnalytics($gtag, clickInstallParam()),

  receivePackages: ($gtag: IGtag) => sendAnalytics($gtag, clickAtHome('RECEIVE_PACKAGES')),
  clickCollectPackages: ($gtag: IGtag) => sendAnalytics($gtag, clickAtHome('CLICK_&_COLLECT')),
  clickCollectCIPackages: ($gtag: IGtag) => sendAnalytics($gtag, clickAtHome('CLICK_&_COLLECT')),
  crossTown: ($gtag: IGtag) => sendAnalytics($gtag, clickAtHome('CROSSTOWN_DELIVERY')),
  returns: ($gtag: IGtag) => sendAnalytics($gtag, clickAtHome('RETURNS')),
  onboarding: ($gtag: IGtag) => sendAnalytics($gtag, clickAtHome('ONBOARDING')),
  myProfile: ($gtag: IGtag) => sendAnalytics($gtag, clickAtHome('MY_PROFILE')),
  earnings: ($gtag: IGtag) => sendAnalytics($gtag, clickAtHome('EARNINGS')),
  history: ($gtag: IGtag) => sendAnalytics($gtag, clickAtHome('HISTORY')),
  defaultSmartPoint: ($gtag: IGtag) => sendAnalytics($gtag, clickAtHome('DEFAULT_SMART_POINT')),
  changeLanguage: ($gtag: IGtag, lang: string) => sendAnalytics($gtag, clickAtHome('CHANGE_LANGUAGE_' + toUpper(lang))),

};


export const ANALYTIC_ROUTING = {
  enterCrosstown: ($gtag: IGtag) => sendAnalytics($gtag, enterCrosstownRouteParams(true)),
  exitCrossTown: ($gtag: IGtag) => sendAnalytics($gtag, enterCrosstownRouteParams(false)),
};

